var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C9.551 1 10 1.449 10 2H6C6 1.449 6.449 1 7 1H9ZM9 0H7C5.895 0 5 0.895 5 2V3H11V2C11 0.895 10.105 0 9 0Z",
    fill: "#8B75A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5C3.173 14.5 2.5 13.827 2.5 13V3.5H13.5V13C13.5 13.827 12.827 14.5 12 14.5H4Z",
    fill: "#DCD5F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4V13C13 13.551 12.551 14 12 14H4C3.449 14 3 13.551 3 13V4H13ZM14 3H2V13C2 14.105 2.895 15 4 15H12C13.105 15 14 14.105 14 13V3Z",
    fill: "#8B75A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.5V3C1.5 2.724 1.724 2.5 2 2.5H14C14.276 2.5 14.5 2.724 14.5 3V4.5H1.5Z",
    fill: "#DCD5F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3V4H2V3H14ZM14 2H2C1.448 2 1 2.448 1 3V5H15V3C15 2.448 14.552 2 14 2ZM9 6H10V13H9V6ZM11 6H12V13H11V6ZM6 6H7V13H6V6ZM4 6H5V13H4V6Z",
    fill: "#8B75A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8246150bca00a456adf8dc5fe4e197ef.svg";
export { ForwardRef as ReactComponent };